<kendo-card width="auto" class="cardContainer">
    <kendo-card-header>
      <h3> 
        {{settings[0]?.key?.area}}
      </h3>
    </kendo-card-header>
    <kendo-card-body>
      <div *ngFor="let s of settings" class="linkContainer">
        <h4>{{ s.key.key }}</h4>
        <div class="row">
        <kendo-textbox class="linkWidth" floatingLabel="Default">
          <input kendoTextBox [(ngModel)]="s.value.default" />
        </kendo-textbox>
        <kendo-textbox class="linkWidth"  floatingLabel="En">
          <input kendoTextBox [(ngModel)]="s.value.en" />
        </kendo-textbox>
        <ece-btn-icon
        [text]="'circ_new_button_save' | i18n"
        [icon]="'save'" (click)="saveSetting(s)"
        ></ece-btn-icon>
        </div> 
      </div> 
    </kendo-card-body>
  </kendo-card>